import React from 'react';
import { X } from 'lucide-react';
import { LeafDivider, Section } from './Shared';
import { HerbSprig, LeafCluster } from './HealingIcons';
export const PainPoints = () => {
  const points = ['Llegar a la consulta sin saber exactamente qué planta indicar para el cuadro que tienes enfrente.', 'Dudar entre varias hierbas porque no tienes una ficha técnica clara que te respalde.', 'No saber qué preparación hacer con esa planta: infusión, tintura, ungüento o decocción.', 'No conocer las contraindicaciones exactas antes de recomendar a una paciente embarazada o medicada.', 'Sin protocolo de seguridad ante interacciones planta-fármaco.', 'Sin recetario de fórmulas concretas: armando cada combinación desde cero en cada consulta.', 'Sin ficha clínica profesional: cada consulta sin registro ni continuidad.', 'Sin saber de dónde proviene tu materia prima ni cómo evaluarla.', 'Pacientes que no vuelven porque no perciben resultados concretos.', 'Cada sesión comienzas de cero, sin estructura real ni respaldo clínico.'];
  return <Section className="max-w-4xl relative" data-id="element-333" data-mp="1u1lkgxytj743">
      <HerbSprig className="hidden lg:block absolute top-10 left-[1%] w-10 h-10 opacity-25 animate-float-soft" color="#6FA524" style={{
      transform: 'rotate(-12deg)'
    }} data-id="element-334" data-mp="1u0smomhu7ry3" />
      <LeafCluster className="hidden lg:block absolute bottom-24 right-[2%] w-12 h-12 opacity-25 animate-float-soft" color="#C9A961" style={{
      animationDelay: '1.4s'
    }} data-id="element-335" data-mp="23s6t7e87hs0q" />
      <div className="text-center mb-12" data-id="element-336" data-mp="1b52jivy64pim">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-display font-bold mb-6 leading-tight text-brand-purpleDark" data-id="element-337" data-mp="1p2r402obpun5">
          ¿Cuántas consultas más vas a trabajar sin un sistema clínico sólido?
        </h2>
        <p className="text-brand-text mb-4 text-sm md:text-base max-w-2xl mx-auto" data-id="element-338" data-mp="30gcsdlmczs7m">
          Eres terapeuta natural. Amas lo que haces. Crees en el poder de las
          plantas medicinales. Pero nadie te dijo que ibas a llegar a la
          consulta sin saber exactamente qué planta indicar, en qué dosis, con
          qué precauciones y para qué cuadro específico.
        </p>

        <p className="text-lg md:text-xl font-medium text-brand-burgundy mt-6 font-serif italic" data-id="element-339" data-mp="225ldffxrg10a">
          No es falta de vocación. No es falta de experiencia. Es falta de un
          sistema.
        </p>
      </div>

      <div className="glass-panel p-6 md:p-10 rounded-3xl mb-12 bg-white/70 border-brand-purple/20" data-id="element-340" data-mp="1afymk65a3e3a">
        <h3 className="font-serif font-bold mb-6 flex items-center text-brand-purpleDark text-base md:text-lg" data-id="element-341" data-mp="1eh20uo7oh22e">
          <X className="w-6 h-6 text-brand-burgundy mr-2 shrink-0" data-id="element-342" data-mp="1je0vr8z61d1n" /> Lo que
          pasa sin el Megapack Saberes Ancestrales:
        </h3>
        <ul className="space-y-4" data-id="element-343" data-mp="qqxzknhypeek">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-344" data-mp="qotz6fj9uxj1" data-mpi={i}>
              <X className="w-5 h-5 text-brand-burgundy/80 mr-3 mt-0.5 shrink-0" data-id="element-345" data-mp="voptto62xclx" />
              <span className="text-brand-text text-sm md:text-base" data-id="element-346" data-mp="o6i60tc7tisu">
                {point}
              </span>
            </li>)}
        </ul>
      </div>

      <LeafDivider data-id="element-347" data-mp="j5c8mi7m17cz" />

      <div className="text-center" data-id="element-348" data-mp="e7j6q1dcazii">
        <h3 className="text-xl md:text-3xl font-display font-bold purple-gradient-text" data-id="element-349" data-mp="e6rduyb4nfvx">
          ¿Y si esta fuera la última consulta que trabajas así?
        </h3>
      </div>
    </Section>;
};